<template>
    <div id="superviseTagging" style="height: 100%">
       <div class="mainHead">
        <div class="route">
          <span class="crumbs"></span><span :class="{link:!btnShow}" @click="goback">校企标注</span><span class="arrow" v-show="!btnShow">></span><span v-show="!btnShow">标注</span>
        </div>
        <div> 
          <el-button type="primary" v-show="btnShow" @click="addTagging" id='btn1'>标注</el-button>
          <el-button type="primary" v-show="!btnShow" @click="goback" id='btn2'>返回</el-button>
        </div>
      </div>
      <div class="mainContent" :style="{height:small}">
        <div id="contain" style="width:100%;height:100%;"></div>
      </div>
    </div>
</template>
<script>
import {ajaxFuncJson} from '@/api/ajax';
import {mapState,mapGetters,mapActions} from 'vuex';
var map,infoWindow,marker;
export default {
    name:"superviseTagging",
    inject:['reload'],//刷新页面
    data() {
        return{
            small:'calc(100% - 99px)',//响应式计算地图高度
            coordinate:[114.086773,22.538328], //可配置项深圳坐标
            btnShow:JSON.parse(sessionStorage.getItem('btnShow')) ,//标注、返回
            markerList:[],//标记点
            removeList:[],//删除标记点
            pointId:[] //标记点id
        }
    },
    destroyed: function () { //离开当前页面触发事件
        sessionStorage.setItem('btnShow',true);
        sessionStorage.setItem('differentiate',true);
        sessionStorage.setItem('menuS','')
        sessionStorage.setItem('menuS2','');
    },
    computed:{ //计算属性
        pointData() { //获取标记信息
           return this.$store.state.pointData
        },
        leftoggle() { //左侧导航伸缩事件
           return this.$store.state.leftoggle
        },
        getmapInfo() { //导航触发监听
           return this.$store.state.menuS2Change
        },
        point: {
            get() { //标记获取
                return this.$store.state.pointData.data
            },
            set(val) { //标记更新
                this.$store.state.pointData.data = val
            }
        }
    },
    watch:{
    'leftoggle'(val) { //地图高度动态计算
      if (val) {
        this.small = 'calc(100% - 58px)';
      } else {
        this.small = 'calc(100% - 99px)';
      }
    },
    getmapInfo(val) { //监听左侧点击
      if(this.pointId.indexOf(sessionStorage.getItem('menuS2')) == -1){
          map.clearInfoWindow(); //关闭全部窗体
       }
        this.markerList.map((a,b)=>{
            if(sessionStorage.getItem('menuS2') == a.Je.customerId){
                infoWindow.setContent(this.markerList[b].content); //窗体内容
                infoWindow.open(map,this.markerList[b].getPosition());
                this.markerList[b].setIcon('../static/img/schoolactive.png');
            }else{
                this.markerList[b].setIcon('../static/img/school.png');
            }
        })
           map.setFitView(); //存在标记点时，地图需将所有标记点展示到可见范围中；
    },
    },
    created(){
        sessionStorage.setItem('differentiate',false); //判断是否可取消状态
        this.getpointAnMap();//获取所有点标记方法
    },
    mounted(){
        map = new AMap.Map('contain', {
            mapStyle: 'amap://styles/darkblue', //自定义地图样式
            resizeEnable: true,
            zoom:12,//级别
            center: this.coordinate//中心点坐标默认:深圳
        });
        this.map() //渲染地图
        map.setFitView(); //存在标记点时，地图需将所有标记点展示到可见范围中；
        if(this.btnShow){ //刷新页面重新注册事件
            map.off('click', this.addMarker); //地图不可标注(map事件)
            if(this.point.length > 0){
                marker.off('click',this.removeMarker); //地图不可标注(marker事件)
            }
        }else{
            map.on('click',this.addMarker); //地图可标注(map事件)
            if(this.point.length > 0){
                marker.on('click',this.removeMarker); //地图可标注(marker事件)
            }
        }
    },
    methods:{
        addTagging(){ //标注按钮
            this.btnShow = false; //按钮切换
            sessionStorage.setItem('btnShow',this.btnShow);
            this.$store.state.btnShow = this.btnShow; //监听左侧导航变化
            map.on('click', this.addMarker); //地图可标注(map事件)
            if(this.point.length > 0){
                marker.on('click',this.removeMarker); //地图可标注(marker事件)
            }
        },
        goback(){ //返回按钮
            this.btnShow = true; //按钮切换
            sessionStorage.setItem('btnShow',this.btnShow);
            this.$store.state.btnShow = this.btnShow; //监听左侧导航变化
            map.off('click',this.addMarker); //地图不可标注(map事件)
            if(this.point.length > 0){
                marker.off('click',this.removeMarker); //地图不可标注(marker事件)
            }
        },
        getpointAnMap() {// 获取客户右侧数据
            let params = {
                 customerId: ''
            }
            ajaxFuncJson('/enterprise/getEnterprisePoin',params).then(res=>{
                if (res.data.status == 200) {
                    sessionStorage.setItem('pointData',JSON.stringify(res.data))
                    this.$store.dispatch('getRightPoint',res.data)
                    map.clearInfoWindow(); //关闭全部
                    this.getLeft(); //刷新左侧导航
                    this.map(); //重新渲染标记
                    map.setFitView(); //存在标记点时，地图需将所有标记点展示到可见范围中；
                } else {
                    this.$message.error(res.data.msg)
                }
            });
        },
        map(){ //地图调用
            // 新增渲染多个标记点
            let iconCar;
            infoWindow = new AMap.InfoWindow({
                isCustom: true,  //使用自定义窗体
                anchor:'bottom-left',
                offset: new AMap.Pixel(38, 40),
            });
            map.remove(this.markerList)	//先移除
            this.markerList = [];	//清空
            this.pointId = [];
            if(this.point.length > 0){
                this.point.forEach((item,index) => {
                    // 不同的类型区分 icon
                    // if(item.type == '1'){
                    //     iconCar = new AMap.Icon({
                    //         size: new AMap.Size(25, 34),
                    //         image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
                    //         imageSize: new AMap.Size(135, 40),
                    //         imageOffset: new AMap.Pixel(-9, -3)
                    //     });
                    // }else if(item.type == '2'){ //起
                    //     iconCar = new AMap.Icon({
                    //         size: new AMap.Size(25, 34),
                    //         image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
                    //         imageSize: new AMap.Size(135, 40),
                    //         imageOffset: new AMap.Pixel(-9, -3)
                    //     });
                    // }else if(item.type == '3'){ //终
                    //     iconCar = new AMap.Icon({
                    //         size: new AMap.Size(25, 34),
                    //         image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
                    //         imageSize: new AMap.Size(135, 40),
                    //         imageOffset: new AMap.Pixel(-95, -3)
                    //     });
                    // }
                    //固定同一个点
                        // 点标记显示内容，HTML要素字符串
                        // var markerContent = '' +
                        //     '<div class="custom-content-marker"><div>' +
                        //     '   <img src="../static/img/school.png">' +
                        //     '</div></div>';
                        iconCar = new AMap.Icon({
                            size: new AMap.Size(60, 60),
                            image: '../static/img/school.png',
                            imageSize: new AMap.Size(60, 60)
                        });
                    //创建标记点
                    marker = new AMap.Marker({
                        position: [item.longitude,item.latitude],
                        map: map,
                        // content: markerContent, //预留后期图标类型区分
                        icon: iconCar, // 将一张图片的地址设置为 icon
                        offset: new AMap.Pixel(-30, -36), // 设置了 icon 以后，设置 icon 的偏移量，以 icon 的 [center bottom] 为原点
                        mapid:item.id, //标记id
                        customerId:item.customerId, //将建筑id与标记绑定
                        mapName:item.buildingName, //将建筑名称显示于此标记
                    });
                    //鼠标详情信息展示
                    if(item.address && !item.detailAddress){
                        marker.content = "<div style='min-width:364px;height:86px;background:rgba(0,0,0,.5);padding:20px;color:#fff;font-size:12px;border:1px solid #198cff;'><div style='font-size:16px;'>"+item.buildingName+"</div><div style='margin-top:10px;white-space: nowrap;'>"+item.address+"</div></div>"
                    }else if(!item.address && item.detailAddress){
                        marker.content = "<div style='min-width:364px;height:86px;background:rgba(0,0,0,.5);padding:20px;color:#fff;font-size:12px;border:1px solid #198cff;'><div style='font-size:16px;'>"+item.buildingName+"</div><div style='margin-top:10px;white-space: nowrap;'>"+item.detailAddress+"</div></div>"
                    }else{
                        marker.content = "<div style='min-width:364px;height:86px;line-height:86px;background:rgba(0,0,0,.5);padding:0 20px;color:#fff;font-size:12px;border:1px solid #198cff;'><div style='font-size:16px;'>"+item.buildingName+"</div></div>"
                    }
                    marker.setLabel({ //固定提示标记
                         offset: new AMap.Pixel(0, 8),
                         content: "<div>" + item.buildingName + "</div>",
                         direction: 'bottom' //设置文本标注方位
                     });
                     marker.on('mouseover', this.infoOpen); //鼠标移入显示事件注册
                     marker.on('mouseout', this.infoClose); //鼠标移出隐藏事件注册
                     marker.on('click',this.removeMarker); //删除标记事件注册
                     this.markerList.push(marker); //缓存标记数组
                     this.pointId.push(item.customerId); //缓存标记id
                     if(item.customerId != '' && item.customerId == sessionStorage.getItem('menuS2')){ //初始化渲染标记窗体及状态
                         infoWindow.setContent(marker.content); //窗体内容
                         infoWindow.open(map,marker.getPosition());
                         marker.setIcon('../static/img/schoolactive.png'); //高亮提示图标
                     }
                });
            }
            //   map.remove(this.removeList)	//先移除
            //   map.add(this.markerList);		//再加点 
            //   this.markerList = [];	//清空
            sessionStorage.setItem('differentiate',false); //判断是否可取消状态
    },
    addMarker(e){ //添加标记
      if(this.isAuth('enterprise:saveEnterprise')) {
          let s2id = sessionStorage.getItem('menuS2');
          if(sessionStorage.getItem('menuS2') !='' && this.pointId.indexOf(s2id) == -1){
              this.$confirm('是否在此处标记校企？', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
              }).then(() => {
                      let params = {
                          customerId: sessionStorage.getItem('menuS2'),
                          longitude: e.lnglat.getLng(), //经度
                          latitude: e.lnglat.getLat() //纬度
                      };
                  ajaxFuncJson("/enterprise/saveEnterprise", params).then(res => {
                      this.getpointAnMap(); //获取标记信息
                  });
              }).catch(() => {});
          }
      }
    },
    removeMarker(e){ //删除标记
      if(this.isAuth('enterprise:delEnterprisePoin')) {
          if(!this.btnShow){
              this.$confirm('是否确定移除当前校企标记？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                }).then(() => {
                    var text = '您在 [ '+e.lnglat.getLng()+','+e.lnglat.getLat()+' ] 的位置单击了地图！';
                        let params = {
                            id: e.target.Je.mapid,
                        };
                    ajaxFuncJson("/enterprise/delEnterprisePoin", params).then(res => {
                        this.getpointAnMap(); //获取标记信息
                    });
                }).catch(() => {});
          }
      }
    },
    infoOpen(e){ //鼠标移入显示窗体
        infoWindow.setContent(e.target.content); //窗体内容
        infoWindow.open(map, e.target.getPosition());//窗体元素
    },
    infoClose(e){ //鼠标移出关闭窗体
    //  map.clearInfoWindow(); 关闭全部
        infoWindow.close(map, e.target.getPosition());
    },
    getLeft(){ //更新右侧已标记状态
      let params = {
          customerId:sessionStorage.getItem('customerId1'), //6期教育局2020.8.19
          buildingName: '',
          target: 1,
      }
      ajaxFuncJson('/basicData/getCustomerList',params).then(res=>{
        res.data.data[0].active = false; //12-26X
          
        sessionStorage.setItem("leftData", JSON.stringify(res.data.data));
        this.$store.dispatch("getLeftDataList", res.data.data);
      })
    }
    }
}
</script>
<style scoped lang="scss">
    @import "@/assets/css/mixin.scss";
    #superviseTagging{
        .mainContent{
            background-color: #fff;
            margin-right: 1.05%;
        }
    }
</style>


// WEBPACK FOOTER //
// src/page/superviseTagging/index.vue